import Status from '../../enums/Status';
import {getCreateAccountPayload} from '../selectors/CreateAccountSelectors';
import Track from '../utils/tracking';
import {SET_CREATE_ACCOUNT_STATUS, UPDATE_CREATE_ACCOUNT_DETAILS} from './action-types';
import {createAccountOnAPI} from './APIActions/CheckoutAPIActions';

export function updateCreateAccountDetails(fieldName, fieldValue) {
  return {
    type: UPDATE_CREATE_ACCOUNT_DETAILS,
    fieldName,
    fieldValue,
  };
}

export function setCreateAccountStatus(status) {
  return {
    type: SET_CREATE_ACCOUNT_STATUS,
    status,
  };
}

export const createAccount = () => (dispatch, getState) => {
  dispatch(setCreateAccountStatus(Status.LOADING));
  
  return dispatch(createAccountOnAPI(getCreateAccountPayload(getState())))
    .then((response) => {
      if (response && response.status === 200 && response.msg) {
        return response.msg.emailVerificationRequired ? Status.SUCCESS : Status.VERIFICATION_SUCCESS;
      }
      Track.error(`Error creating account on API: ${JSON.stringify(response)}`);
      return Status.ERROR;
    })
    .catch((error) => {
      Track.error(`Caught error sending create account data to API: ${error}`);
      return Status.ERROR;
    })
    .then(status => dispatch(setCreateAccountStatus(status)));
};
